const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Runs fn(item) for every item with at most `limit` in flight.
// If shouldStop(err) returns true for a failure, no new items are started.
// Resolves to { ok: [item], failed: [{ item, err }], skipped: [item] }.
export default async function runWithConcurrency(
  items,
  limit,
  fn,
  { delayMs = 0, onProgress, shouldStop } = {}
) {
  const ok = [];
  const failed = [];
  let next = 0;
  let done = 0;
  let stopped = false;

  const worker = async () => {
    while (!stopped && next < items.length) {
      const item = items[next++];
      try {
        await fn(item);
        ok.push(item);
      } catch (err) {
        failed.push({ item, err });
        if (shouldStop?.(err)) stopped = true;
      }
      done += 1;
      onProgress?.(done, items.length);
      if (delayMs && !stopped && next < items.length) await sleep(delayMs);
    }
  };

  const workers = Array.from(
    { length: Math.max(1, Math.min(limit, items.length)) },
    worker
  );
  await Promise.all(workers);

  const handled = new Set([...ok, ...failed.map((f) => f.item)]);
  const skipped = items.filter((item) => !handled.has(item));
  return { ok, failed, skipped };
}
